module.exports = __webpack_public_path__ + "img/clipboard.d8dad248.svg";